module.exports = __webpack_public_path__ + "img/5_izbove.5526d6fc.jpg";